import SingleAPI from "./singleApi";

export default SingleAPI
